module.exports = __webpack_public_path__ + "img/heart-filled.466850a0.svg";